export const CANVAS_WIDTH = 1920;
export const CANVAS_HEIGHT = 1280;
